import { render, staticRenderFns } from "./MastheadStoryStyle.vue?vue&type=template&id=68f036b4&"
import script from "./MastheadStoryStyle.vue?vue&type=script&lang=js&"
export * from "./MastheadStoryStyle.vue?vue&type=script&lang=js&"
import style0 from "./MastheadStoryStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports